import { Menu, User, UserPlus, LogOut, Ghost } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { logout } from "@/store/slices/authSlice";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const Navbar = () => {
  const { toggleSidebar } = useSidebar();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };
  const handleLogin = () => {
    navigate('/login');
  };
  const handleRegister = () => {
    dispatch(logout());
    navigate('/register');
  };

  return (
    <nav className="h-16 border-b flex items-center justify-between px-6 bg-white shadow-sm">
      <div className="flex items-center gap-4">
        {isAuthenticated && (
          <>
            <Button variant="ghost" size="icon" onClick={toggleSidebar} className="lg:hidden hover:bg-slate-50">
              <Menu className="h-5 w-5 text-slate-600" />
            </Button>
            <SidebarTrigger className="hidden lg:flex hover:bg-slate-50" />
          </>
        )}
        <span className="text-xl font-semibold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
          THMN.AI
        </span>
      </div>
      <div className="flex items-center gap-3">
        {isAuthenticated ? (
          <>
            <span className="text-sm text-slate-600 hidden md:inline-block">
              {(user?.first_name || user?.last_name) && `${user?.first_name} ${user?.last_name} | `}
              {user?.company?.name && user.company.name}
            </span>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="hover:bg-slate-50">
                  <User className="h-5 w-5 text-slate-600" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={handleLogout}>
                  <LogOut className="mr-2 h-4 w-4" />
                  <span>Logout</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        ) : (
          <>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/register')}
              className="hover:bg-slate-50"
            >
              Register
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={() => navigate('/login')}
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium"
            >
              Login
            </Button>
          </>
        )}
      </div>
    </nav>
  );
}